var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { createPortal } from "react-dom";
import * as React from "react";
import { PopupContainer } from "./popup";
import { SurveyElementBase } from "../../reactquestion_element";
import { PopupModalManager, settings } from "survey-core";
var PopupModal = /** @class */ (function (_super) {
    __extends(PopupModal, _super);
    function PopupModal(props) {
        var _this = _super.call(this, props) || this;
        _this.modalManager = _this.createPopupModalManager();
        _this.isInitialized = false;
        _this.init = function () {
            if (!_this.isInitialized) {
                settings.showDialog = function (dialogOptions, rootElement) { return _this.modalManager.addDialog(dialogOptions, rootElement); };
                _this.isInitialized = true;
            }
        };
        _this.clean = function () {
            if (_this.isInitialized) {
                settings.showDialog = undefined;
                _this.isInitialized = false;
            }
        };
        _this.state = { changed: 0 };
        _this.descriptor = {
            init: _this.init,
            clean: _this.clean
        };
        return _this;
    }
    PopupModal.prototype.createPopupModalManager = function () {
        var _this = this;
        var modalManager = new PopupModalManager();
        modalManager.onModalsChangedCallback = function () {
            _this.setState({ changed: _this.state.changed + 1 });
        };
        return modalManager;
    };
    PopupModal.addModalDescriptor = function (descriptor) {
        if (!settings.showDialog) {
            descriptor.init();
        }
        this.modalDescriptors.push(descriptor);
    };
    PopupModal.removeModalDescriptor = function (descriptor) {
        descriptor.clean();
        this.modalDescriptors.splice(this.modalDescriptors.indexOf(descriptor), 1);
        if (!settings.showDialog && this.modalDescriptors[0]) {
            this.modalDescriptors[0].init();
        }
    };
    PopupModal.prototype.renderElement = function () {
        return React.createElement(React.Fragment, null, this.modalManager.getModals().map(function (model) { return createPortal(React.createElement(PopupContainer, { model: model }), model.container, model.uniqueId.toString()); }));
    };
    PopupModal.prototype.componentDidMount = function () {
        PopupModal.addModalDescriptor(this.descriptor);
    };
    PopupModal.prototype.componentWillUnmount = function () {
        this.modalManager.clear();
        PopupModal.removeModalDescriptor(this.descriptor);
    };
    PopupModal.modalDescriptors = [];
    return PopupModal;
}(SurveyElementBase));
export { PopupModal };
